module.exports = __webpack_public_path__ + "img/drug-7.96e189ce.png";